import { JSX } from "react";
import { Container, Grid } from "@mui/material";

// Icons
import banner from "@/assets/icons/layers/footer.svg";

const Footer = (): JSX.Element => {
	return (
		<Container disableGutters maxWidth={false}>
			<Grid container justifyContent="center" className="footer-area">
				<Grid item mt={1} className="!mt-0">
					<img src={banner} className="footer-img my-5" alt="footer banner" />
				</Grid>
			</Grid>
		</Container>
	);
};

export default Footer;
